import axios from "axios";

const http = axios.create({
  // baseURL: "http://localhost:80/Futeboleiros-back/",
  baseURL: "https://futeboleiros-oficial.000webhostapp.com/",
  timeout: 1000000,
});

export default http;
